export default "__VITE_ASSET__6237d50f__"